// 崩した瞬間 (弾いてボスの体幹が尽きた時) の手応えの比較版 (2026-10-14・DEV だけ・全ボス共通)。
//   元＝ユーザー 10-14「脳汁の出る演出についてはもっと調べてもらって、ブラッシュアップできるならやっていってほしい。
//   これはボスの致命の演出以外でもお願いしたいこと」。調べ＝docs/research/2026-10-14-reward-fx-survey.md の ③。
//   10-06 の金の染め (`?parryDownFx=z`) は「画面が光ったようにしか感じない」で見送り → 画面の色は足さず、止めと体で見せる。
//     now = 今まで (普段の弾きと同じ止め 約0.15〜0.2秒)
//     a   = 止めだけ +70ms
//     b   = a ＋ 止めが明けた瞬間にボスの体がガクッと後ろへ押されて沈み、0.45秒で元の崩れの絵へ戻る (描くだけ・位置と当たりは不変)
//   配布版の既定 = b (2026-10-15 ユーザー パック 1014d D-1「止めを長く＋体の崩れ」・D-2 長さちょうどいい・D-3 押された感じがする)。
//   前の版 = DEV ?breakStop=now。

import type { GameState } from './types'

export type BreakStopLook = 'now' | 'a' | 'b'

let look: BreakStopLook = (() => {
  if (!import.meta.env.DEV || typeof window === 'undefined') return 'b'
  const v = new URLSearchParams(window.location.search).get('breakStop')
  return v === 'a' || v === 'now' ? v : 'b'
})()
export function setBreakStopLook(l: BreakStopLook): void { look = l }
export function getBreakStopLook(): BreakStopLook { return look }

/** 崩した瞬間に足す止めの長さ (ms)。 */
export const BREAK_STOP_EXTRA_MS = 70
export function breakStopExtraMs(): number { return look === 'now' ? 0 : BREAK_STOP_EXTRA_MS }

/** 体の崩れ (b) の形。 */
export const BREAK_JOLT = {
  pushPx: 16,     // 主人公から離れる向きへ押される幅
  dropPx: 10,     // 沈む深さ
  hitSec: 0.07,   // ここまでで一番押された所
  endSec: 0.45,   // ここで元へ戻り切る (fx が消える 0.5秒より前)
} as const

const easeOut = (x: number): number => 1 - (1 - x) * (1 - x)
const smooth = (x: number): number => x * x * (3 - 2 * x)

/** 崩れてからの経過秒 t での描画のずれ。away = 主人公から離れる向き (+1 右)。純関数 (テスト対象)。 */
export function breakJoltAt(t: number, away: number): { dx: number; dy: number } {
  if (t < 0 || t >= BREAK_JOLT.endSec) return { dx: 0, dy: 0 }
  const k = t < BREAK_JOLT.hitSec
    ? easeOut(t / BREAK_JOLT.hitSec)
    : 1 - smooth((t - BREAK_JOLT.hitSec) / (BREAK_JOLT.endSec - BREAK_JOLT.hitSec))
  return { dx: away * BREAK_JOLT.pushPx * k, dy: BREAK_JOLT.dropPx * k }
}

/** いまのボスの描画のずれ (b の時だけ)。崩した瞬間の印 (parry_spark の broke・parry_down) から数える。 */
export function breakJoltOffset(state: GameState): { dx: number; dy: number } {
  if (look !== 'b') return { dx: 0, dy: 0 }
  let t0: number | null = null
  for (const f of state.fx) {
    const broke = (f.kind === 'parry_spark' && f.broke) || f.kind === 'parry_down'
    if (broke && (t0 === null || f.t > t0)) t0 = f.t
  }
  if (t0 === null) return { dx: 0, dy: 0 }
  const away = state.boss.x >= state.player.x ? 1 : -1
  return breakJoltAt(state.time - t0, away)
}
